const useSlugValue = (allSlugs, locale) => {
  const filteredSlug = allSlugs?.filter(slug => slug.locale === locale)

  if (filteredSlug?.length > 0) {
    return filteredSlug[0].value
  }
  return ""
}

export default useSlugValue
